import { Component, OnInit } from '@angular/core';
import { GlobalComponent } from '../../global-component';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  copyright = GlobalComponent.strings.copyright;

  constructor() { }

  ngOnInit(): void {
  }

}
